import { render, staticRenderFns } from "./Sender.vue?vue&type=template&id=05f2e418&scoped=true"
import script from "./Sender.vue?vue&type=script&lang=js"
export * from "./Sender.vue?vue&type=script&lang=js"
import style0 from "./Sender.vue?vue&type=style&index=0&id=05f2e418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f2e418",
  null
  
)

export default component.exports